// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"9503aa5d","478":"cc52b2cd","726":"3f3bafb2"}[chunkId] + ".chunk.js";
};